import { render, staticRenderFns } from "./MainBookTypesCRUD.vue?vue&type=template&id=e7cb6d6c"
import script from "./MainBookTypesCRUD.vue?vue&type=script&lang=js"
export * from "./MainBookTypesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports